module.exports = __webpack_public_path__ + "static/the-front-of-three-trucks-9cb5c39af23ee7e73ecf19de8812be0c.jpg";